import React, { useState, useContext } from 'react';
import { Box } from '../design-system';
import { useLocation, Link } from 'react-router';
import styled, { css } from 'styled-components';
import IconListItem from './IconListItem';
import SideBarOption from './SidebarOption';
import SidebarToggleButton from './SidebarToggleButton';
import Logo from './Logo';
import { SIDEBAR_OPTIONS } from '../globalConstants';
import { Session } from '../contexts/sessionContext';
import G from '../../public/images/G.png';

const SideBarContainer = styled.div`
  ${({ theme }) => css`
    position: relative;
    padding: 20px 0};
    background-color: ${theme.colors.sideBarBG};
  `}
`;

const Brand = styled(Box)`
  padding: 0 30px;
  margin: 1rem 0;
`;

const UL = styled.ul`
  list-style: none;
  padding: 0 5px;
  margin: 0;
`;

const IconsUL = styled(UL)`
  margin-bottom: 5px;
  margin-top: 1rem;
`;

const Sidebar = () => {
  const {
    state: {
      user: { agency, permissions },
    },
  } = useContext(Session);
  const { pathname } = useLocation();
  const sideBarItem = JSON.parse(localStorage.getItem('isSideBarOpen'));
  const sideBarStatus = sideBarItem !== null ? sideBarItem : true;
  const [isSideBarOpen, setSideBar] = useState(sideBarStatus);

  const onClick = () => {
    setSideBar(!isSideBarOpen);
    localStorage.setItem('isSideBarOpen', String(!isSideBarOpen));
  };

  const hasPermission = (permission: string) =>
    permissions && permissions.includes(permission);

  return (
    <SideBarContainer>
      {isSideBarOpen ? (
        <>
          <SidebarToggleButton isOpen={isSideBarOpen} onClick={onClick} />
          <Brand>
            <Logo width="10rem" />
          </Brand>
          <UL>
            {SIDEBAR_OPTIONS.map((option) =>
              option.route === '/vault'
                ? agency &&
                  agency.plan_id !== 1 &&
                  hasPermission(option.permission) && (
                    <SideBarOption key={option.route} option={option} />
                  )
                : hasPermission(option.permission) && (
                    <SideBarOption key={option.route} option={option} />
                  ),
            )}
          </UL>
        </>
      ) : (
        <>
          <SidebarToggleButton isOpen={isSideBarOpen} onClick={onClick} />
          <Link to="/">
            <img src={G} width={55} alt="" />
          </Link>
          <IconsUL>
            {SIDEBAR_OPTIONS.map((option) => {
              const { route, permission } = option;
              const props = {
                key: route,
                pathname,
                option,
              };
              return route === '/vault'
                ? agency &&
                    agency.plan_id !== 1 &&
                    hasPermission(permission) && <IconListItem {...props} />
                : hasPermission(permission) && <IconListItem {...props} />;
            })}
          </IconsUL>
        </>
      )}
    </SideBarContainer>
  );
};

export default Sidebar;
